import { Injectable } from '@angular/core';
import type { Product } from '../../Components/Home/product-app/product-app';

@Injectable({ providedIn: 'root' })
export class ProductSelectionService {
  selectedApps: Product[] = [];
}
